import { render, staticRenderFns } from "./PurchaseReceivingDetail.vue?vue&type=template&id=5a504bfe&scoped=true&"
import script from "./PurchaseReceivingDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a504bfe",
  null
  
)

export default component.exports